// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x4-w","right":"styles_right__2OP1u"};